import { useState } from "react";
import { STORAGE_KEY } from "../constants";
import { config } from "../lib/config";
import "./AgeGate.css";

type Props = {
  onVerified: () => void;
};

export function AgeGate({ onVerified }: Props) {
  const [declined, setDeclined] = useState(false);

  function confirm21() {
    localStorage.setItem(STORAGE_KEY, "1");
    onVerified();
  }

  if (declined) {
    return (
      <div className="age-gate" id="main-content">
        <div className="age-gate__panel" role="alert" aria-live="polite">
          <p className="age-gate__brand">{config.brandLockup}</p>
          <h1 className="age-gate__title">Access restricted</h1>
          <p className="age-gate__copy">
            This site is only for adults 21+. You can close this tab or window.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="age-gate" id="main-content">
      <div className="age-gate__panel" role="dialog" aria-modal="true" aria-labelledby="age-title">
        <p className="age-gate__brand">{config.brandLockup}</p>
        <p className="age-gate__mark" aria-hidden="true">
          21<span className="age-gate__mark-plus">+</span>
        </p>
        <h1 id="age-title" className="age-gate__title age-gate__title--upper">
          Are you 21 or older?
        </h1>
        <p className="age-gate__copy">
          Selecting <strong>Yes</strong> below acknowledges that you meet the age requirement and are
          permitted to view the site&rsquo;s adult content.
        </p>
        <div className="age-gate__actions">
          <button
            type="button"
            className="age-gate__btn age-gate__btn--primary"
            onClick={confirm21}
          >
            Yes
          </button>
          <button
            type="button"
            className="age-gate__btn age-gate__btn--ghost"
            onClick={() => setDeclined(true)}
          >
            Exit
          </button>
        </div>
      </div>
    </div>
  );
}
